import React from 'react';
import { Box, Flex, Text } from '@spothero/ui';
import { StarRating } from 'common/star-rating';
export const NoReviews = () => {
    return (<Box data-testid="no-reviews">
            <Flex alignItems="center" marginBottom={4}>
                <StarRating rating={5} filledColor="gray.300" width={4} height={4} showLabel={false}/>
                <Text marginLeft={1} fontWeight="semibold" fontSize="sm">
                    No Reviews
                </Text>
            </Flex>
            <Text fontSize="sm">No reviews from SpotHero customers.</Text>
        </Box>);
};
